import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import { Field } from '../_models/field.model';
import {
  Import,
  ImportColumnsPayload,
  ImportColumnsResponse,
} from '../_models/import.model';

/**
 * Import action types
 */
export enum ImportActionTypes {
  LOAD_IMPORTS = '[Import] Imports',
  LOAD_IMPORTS_SUCCESS = '[Import] Imports Success',
  LOAD_IMPORTS_FAILED = '[Import] Imports Failed',
  DELETE_IMPORT = '[Import] Delete Import',
  DELETE_IMPORT_SUCCESS = '[Import] Delete Import Success',
  DELETE_IMPORT_FAILED = '[Import] Delete Import Failed',
  CREATE_IMPORT = '[Import] Create Import',
  CREATE_IMPORT_SUCCESS = '[Import] Create Import Success',
  CREATE_IMPORT_FAILED = '[Import] Create Import Failed',
  IMPORT_COLUMNS = '[Import] Columns Import',
  IMPORT_COLUMNS_SUCCESS = '[Import] Columns Import Success',
  IMPORT_COLUMNS_FAILED = '[Import] Columns Import Failed',
  IMPORT_FIELDS = '[Import] Fields Import',
  IMPORT_FIELDS_SUCCESS = '[Import] Fields Import Success',
  IMPORT_FIELDS_FAILED = '[Import] Fields Import Failed',
  ACTIVATE_IMPORTS = '[Import] Activate Import',
  ACTIVATE_IMPORTS_SUCCESS = '[Import] Activate Import Success',
  ACTIVATE_IMPORTS_FAILED = '[Import] Activate Import Failed',
  RUN_IMPORT = '[Import] Import',
  RUN_IMPORT_SUCCESS = '[Import] Run Import Success',
  RUN_IMPORT_FAILED = '[Import] Run Import Failed',
  GET_IMPORT = '[Import] Get Import',
  GET_IMPORT_SUCCESS = '[Import] Get Import Success',
  GET_IMPORT_FAILED = '[Import] Get Import Failed',
  UPDATE_IMPORT = '[Import] Update Import',
  UPDATE_IMPORT_SUCCESS = '[Import] Update Import Success',
  UPDATE_IMPORT_FAILED = '[Import] Update Import Failed',
  CHECK_IMPORT_NAME_STATUS = '[Import] Check Import Name Status',
  CHECK_IMPORT_NAME_STATUS_SUCCESS = '[Import] Check Import Name Status Success',
  CHECK_IMPORT_NAME_STATUS_FAILED = '[Import] Check Import Name Status Failed',
  RESET = '[Import] Reset',
}

/**
 * Operations
 */
export class ActivateImport extends Reference implements Action {
  readonly type = ImportActionTypes.ACTIVATE_IMPORTS;

  constructor(public payload: Import) {
    super();
  }
}

export class ActivateImportSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.ACTIVATE_IMPORTS_SUCCESS;

  constructor(public payload:Import) {
    super();
  }
}

export class ActivateImportFailed extends Reference implements Action {
  readonly type = ImportActionTypes.ACTIVATE_IMPORTS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadImports implements Action {
  readonly type = ImportActionTypes.LOAD_IMPORTS;

  constructor(public tableId: string, public force?: boolean) {}
}

export class LoadImportsSuccess implements Action {
  readonly type = ImportActionTypes.LOAD_IMPORTS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Import>) {}
}

export class LoadImportsFailed implements Action {
  readonly type = ImportActionTypes.LOAD_IMPORTS_FAILED;

  constructor(public payload: Error) {}
}

export class DeleteImport extends Reference implements Action {
  readonly type = ImportActionTypes.DELETE_IMPORT;

  constructor(public tableId: string, public importId: string) {
    super();
  }
}

export class DeleteImportSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.DELETE_IMPORT_SUCCESS;

  constructor(public tableId: string, public importId: string) {
    super();
  }
}

export class DeleteImportFailed extends Reference implements Action {
  readonly type = ImportActionTypes.DELETE_IMPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateImport extends Reference implements Action {
  readonly type = ImportActionTypes.CREATE_IMPORT;

  constructor(public payload: any) {
    super();
  }
}

export class CreateImportSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.CREATE_IMPORT_SUCCESS;

  constructor(public payload: Import) {
    super();
  }
}

export class CreateImportFailed extends Reference implements Action {
  readonly type = ImportActionTypes.CREATE_IMPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ColumnImport extends Reference implements Action {
  readonly type = ImportActionTypes.IMPORT_COLUMNS;

  constructor(public tableId: string, public payload: ImportColumnsPayload) {
    super();
  }
}

export class ColumnImportSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.IMPORT_COLUMNS_SUCCESS;

  constructor(public tableId: string, public payload: ImportColumnsResponse) {
    super();
  }
}

export class ColumnImportFailed extends Reference implements Action {
  readonly type = ImportActionTypes.IMPORT_COLUMNS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ImportFields implements Action {
  readonly type = ImportActionTypes.IMPORT_FIELDS;

  constructor(public tableId: string) {}
}

export class ImportFieldsSuccess implements Action {
  readonly type = ImportActionTypes.IMPORT_FIELDS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Field>) {}
}

export class ImportFieldsFailed implements Action {
  readonly type = ImportActionTypes.IMPORT_FIELDS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class RunImport implements Action {
  readonly type = ImportActionTypes.RUN_IMPORT;

  constructor(public importId: string) {}
}

export class RunImportSuccess implements Action {
  readonly type = ImportActionTypes.RUN_IMPORT_SUCCESS;

  constructor(public importId: string) {}
}

export class RunImportFailed implements Action {
  readonly type = ImportActionTypes.RUN_IMPORT_FAILED;

  constructor(public payload: Error) {}
}

export class GetImport implements Action {
  readonly type = ImportActionTypes.GET_IMPORT;

  constructor(public importId: string) {}
}

export class GetImportSuccess implements Action {
  readonly type = ImportActionTypes.GET_IMPORT_SUCCESS;

  constructor(public importId: string, public payload: Import) {}
}

export class GetImportFailed implements Action {
  readonly type = ImportActionTypes.GET_IMPORT_FAILED;

  constructor(public payload: Error, public importId: string) {}
}

export class UpdateImport extends Reference implements Action {
  readonly type = ImportActionTypes.UPDATE_IMPORT;

  constructor(public payload: Import) {
    super();
  }
}

export class UpdateImportSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.UPDATE_IMPORT_SUCCESS;

  constructor(public payload: Import) {
    super();
  }
}

export class UpdateImportFailed extends Reference implements Action {
  readonly type = ImportActionTypes.UPDATE_IMPORT_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CheckImportNameStatus extends Reference implements Action {
  readonly type = ImportActionTypes.CHECK_IMPORT_NAME_STATUS;

  constructor(public appId: string, public payload: any) {
    super();
  }
}

export class CheckImportNameStatusSuccess extends Reference implements Action {
  readonly type = ImportActionTypes.CHECK_IMPORT_NAME_STATUS_SUCCESS;

  constructor(public appId:string, public payload: any) {
    super();
  }
}

export class CheckImportNameStatusFailed extends Reference implements Action {
  readonly type = ImportActionTypes.CHECK_IMPORT_NAME_STATUS_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ImportActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadImports
  | LoadImportsSuccess
  | LoadImportsFailed
  | DeleteImport
  | DeleteImportSuccess
  | DeleteImportFailed
  | CreateImport
  | CreateImportSuccess
  | CreateImportFailed
  | ColumnImport
  | ColumnImportSuccess
  | ColumnImportFailed
  | ImportFields
  | ImportFieldsSuccess
  | ImportFieldsFailed
  | RunImport
  | RunImportSuccess
  | RunImportFailed
  | GetImport
  | GetImportSuccess
  | GetImportFailed
  | UpdateImport
  | UpdateImportSuccess
  | UpdateImportFailed
  | Reset
  | ActivateImport
  | ActivateImportSuccess
  | ActivateImportFailed
  | CheckImportNameStatus
  | CheckImportNameStatusSuccess
  | CheckImportNameStatusFailed
  ;
